import { useLanguage } from "../contexts/language";

export default function String({ s, l }) {
  const { content } = useLanguage();
  return content(s, l);
}
